// src/components/ui/Modal/ModalBody.tsx
import React from 'react';
import { useResponsive } from '@/hooks/useResponsive';
import styles from './ModalBody.module.css';

export interface ModalBodyProps {
  children: React.ReactNode;
  className?: string;
  scrollable?: boolean; // Пропс для управления скроллом
}

export const ModalBody: React.FC<ModalBodyProps> = ({
  children,
  className = '',
  scrollable = true // По умолчанию скролл включен
}) => {
  // Используем хук адаптивности для определения типа устройства
  const { isMobile } = useResponsive();
  
  return (
    <div className={`
      ${styles.body} 
      ${isMobile ? styles.bodyMobile : ''} 
      ${scrollable ? styles.scrollable : styles.nonScrollable} 
      ${isMobile ? styles.bodyTextMobile : styles.bodyText} 
      ${className}
    `}>
      {children}
    </div>
  );
};